import { customJsonParser, camelToSnakeCase, snakeToCamelCase } from '@utils/textHelpers';
import queryString, { StringifyOptions } from 'query-string';
import { NavigateOptions, useSearchParams } from 'react-router';
import { useSaveFilters } from '@hooks/useSaveFilters';
import { QueryParam, QueryParams, SetParamsOptions } from './types';
import { initialParams } from './constants';

const options: StringifyOptions = {
  arrayFormat: 'separator',
  skipEmptyString: true,
  skipNull: true,
  arrayFormatSeparator: ';',
};

export const useQueryParams = () => {
  const [state, setState] = useSearchParams();
  const saveFilters = useSaveFilters();

  const getParams = (): QueryParams => {
    let newParams: QueryParams = customJsonParser<QueryParams>(
      queryString.parse(state.toString().replace(/%3B/gi, ';'), options),
      snakeToCamelCase,
    );
    for (const [k, v] of Object.entries(newParams)) {
      if (!k || !v) continue;
      const key = k as QueryParam;
      const value = (v as string) || '';
      if (Array.isArray(initialParams[key]) && !Array.isArray(value)) {
        newParams = { ...newParams, [key]: [value] };
      } else newParams = { ...newParams, [key]: value };
    }
    return newParams;
  };

  const params = getParams();

  const parseParams = (paramsToParse: Record<string, unknown>, opt?: StringifyOptions) => {
    const parsed = queryString.stringify(customJsonParser(paramsToParse, camelToSnakeCase), {
      ...options,
      ...opt,
    });
    if (parsed.length) return `?${parsed}`;
    return parsed;
  };

  const setParams = (newParams: QueryParams, opt?: SetParamsOptions & NavigateOptions) => {
    const mergedParams = opt?.disableMerging ? { ...newParams } : { ...params, ...newParams };
    setState(new URLSearchParams(parseParams(mergedParams)), opt);
    if (opt?.disableSaveFilters) return;
    saveFilters(mergedParams);
  };

  const setParam = (key: keyof QueryParams, value: unknown) => {
    setParams({ ...params, [key]: value });
  };

  return {
    params,
    setParam,
    setParams,
    parseParams,
    searchParams: state,
  };
};
